/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = '<b>' + formatPrice(price) + '</b>';
    if (comparing) {
      res +=
        ' <span class="ais-hit--price-striked"><span>' +
        formatPrice(compare_at_price) +
        '</span></span> ';
      res +=
        ' <span class="ais-hit--price-discount" style="font-weight: ' +
        Math.floor(discount_ratio * 10) * 100 +
        ';">-' +
        Math.floor(discount_ratio * 100) +
        '%</span>';
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();

    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      if(this.meta){
        if(this.meta['bundles-config'] && this.meta['bundles-config'].bundle_enable == "true"){
          this.price = this.meta['bundles-config'].bundle_price  / 100;
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    isBundle: function isBundle() {
      if(this.meta){
        if(this.meta['bundles-config'] && this.meta['bundles-config'].bundle_enable == "true"){
          return ' d-none@xs';
        }
      }
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }

      if(this.meta){
        if(this.meta['bundles-config'] && this.meta['bundles-config'].bundle_enable == "true"){
          this.price = this.meta['bundles-config'].bundle_price / 100;
        }
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );

    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      if(this.collectionTile == 'collection-content-tile'){
        return (this.handle);
      } else {
        return (
          '/products/' +
          this.handle +
          (addVariantId ? '?variant=' + this.objectID : '')
        );
      }
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    productLabel: function productLabel() {
      var res = '';

      if (this.meta) {
        if (this.meta.label) {
          var label = JSON.parse(this.meta.label.linked_label)['references'];
          let obj = null;
          for (let i = 0; i < label.length; i++) {
            if (label[i].section == 'product_labels') {
              obj = label[i];
            }
          }

          if(obj){
            var badgeTitle = theme.badges['title_'+obj.index];
            var badgeColourPrimary = theme.badges['colour_primary_'+obj.index];
            var badgeColourSecondary = theme.badges['colour_secondary_'+obj.index];
            var label_styles = '';

            if (badgeColourSecondary != '') {
              label_styles = 'style="background: linear-gradient(to right,'+ badgeColourPrimary +','+badgeColourSecondary +');"'
            } else if (badgeColourPrimary != '') {
              label_styles = 'style="background-color: ' + badgeColourPrimary +';"'
            }

            if (badgeTitle != '') {
              res = '<div class="c-label"'+ label_styles+ '>'+ badgeTitle + '</div>'
            }
          }

        }

      }
      return res;
    },

    productID: function productID() {
      return this.id;
    },

    productDetails: function productDetails() {

      if (this.product_type == 'Paddle Board' || this.product_type == 'Paddleboard') {
        var res = '';
        if (this.meta) {
          if (this.meta.description) {
            res = '<div class="ais-hit--details-small d-none"><div class="tooltip-inner">'

            if(this.meta.description.max_rider_weight) {
              var max_rider_weight = this.meta.description.max_rider_weight.split('|');
              res += '<p> <span><img loading="lazy" class=\"c-product-details__icon \" src=\"'+ theme.product_details.max_rider_weight_icon +'\"/></span>'
              res +=  '<span>' + theme.product_details.max_rider_weight +': '+ max_rider_weight[0] + '</span></p>'
            }
            if(this.meta.description.rider_style) {
              var rider_style = this.meta.description.rider_style.split('|');
              res += '<p><span><img loading="lazy" class=\"c-product-details__icon \" src=\"'+ theme.product_details.rider_style_icon +'\"/></span>'
              res += '<span>' + theme.product_details.rider_style +': '+ rider_style[0] + '</span></p>'
            }
            if(this.meta.description.min_experience) {
              var min_experience = this.meta.description.min_experience.split('|');
              res += '<p><span><img loading="lazy" class=\"c-product-details__icon \" src=\"'+ theme.product_details.min_experience_icon +'\"/></span>'
              res += '<span>' + theme.product_details.min_experience +': '+ min_experience[0] + '</span></p>'
            }
            res += '</div></div>'
          }
        }
        return res;
      }

    },

    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {

      if (this._highlightResult) {
        var res = '';
        if (this._highlightResult.title && this._highlightResult.title.value) {
          res = algolia.helpers.fullEscapedAttribute(
            this._highlightResult.title.value
          );
        }

        if (
          !this._distinct &&
          this.variant_title &&
          this.variant_title !== 'Default Title' &&
          this.variant_title !== 'Default'
        ) {
          res += ' <span class="algolia-variant">(' + res + ')</span>';
        }
        return res;
      } else {
        if (this.title) {
          res = algolia.helpers.fullEscapedAttribute(
            this.title
          );
          return res;
        }
      }

    },

    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if(this._highlightResult) {
        if (
          this._highlightResult.product_type &&
          this._highlightResult.product_type.value
        ) {
          return algolia.helpers.fullEscapedAttribute(
            this._highlightResult.product_type.value
          );
        } else {
          return '';
        }
      }
    },

    fullEscapedHTMLProductTypeString: function fullEscapedHTMLProductTypeString() {
        if (this.product_type) {
          return algolia.helpers.fullEscapedAttribute(
            this.product_type
          );
        } else {
          return '';
        }
    },

    fullEscapedHTMLProductDescription: function fullEscapedHTMLProductDescription() {
      if(this._highlightResult) {
        if (
          this._highlightResult.body_html_safe &&
          this._highlightResult.body_html_safe.value
        ) {
          var truncatedText = this._highlightResult.body_html_safe.value.trim().split(" ").splice(0,12).join(" ")+'...';
          return algolia.helpers.fullEscapedAttribute(
            truncatedText
          );
        } else {
          return '';
        }
      } else {
        if (this.content) {
          var truncatedText = this.content.trim().split(" ").splice(0,12).join(" ")+'...';
          return algolia.helpers.fullEscapedAttribute(
            truncatedText
          );
        }
      }

    },

    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.vendor.value
        );
      } else {
        return '';
      }
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this.image;

      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }

      if(image.indexOf("https://cld.accentuate.io") == 0 || image.indexOf("https://images.accentuate.io/") == 0){
        
        return image // Render accentuate image as specified in 'collection.liquid'
        
      } else {

        var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim

        if (size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
      }
    },


    sizedSecondaryImage: function sizedSecondaryImage(text, render) {

      if(this.meta && this.meta.accentuate) {
        var image = JSON.parse(this.meta.accentuate.collections_grid_hover_image);
        var imageSrc = image[0].cloudinary_src
        var imageSrcToString = imageSrc.toString()
  
        if(imageSrcToString.indexOf("https://cld.accentuate.io") == 0){
          return '<img loading="lazy" src="' + imageSrcToString + 'w_287,h_287,c_fill' + '" class="ais-hit--picture-hover" width="287" height="287">'  // Render accentuate image as specified in 'collection.liquid'
        }

      }
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        if (this.image) {
          return this.image;
        } else {
        var image = this._distinct ? this.product_image : this.image;
        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }
        if (_size === 'original') {
          return image;
        }
        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
        }
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);